<template>
  <div>
    <mdb-row>
      <mdb-col md="4" style="margin-bottom: 10px;">
        <div class="form__group">
          <div class="form__group">
            <label for="beneficiary-state-home" class="form__label">Estado:</label>
            <input
              type="text"
              v-model="state"
              id="beneficiary-state-home"
              class="form__input"
              disabled
            />
            <validation-error :validation="$v.state" />
          </div>
        </div>
      </mdb-col>

      <mdb-col md="4" style="margin-bottom: 10px;">
        <div class="form__group">
          <div class="form__group">
            <label for="beneficiary-city-home" class="form__label">Ciudad:</label>
            <input type="text" v-model="city" id="beneficiary-city-home" class="form__input" disabled />
            <validation-error :validation="$v.city" />
          </div>
        </div>
      </mdb-col>
    </mdb-row>

    <mdb-row>
      <mdb-col md="2" style="margin-bottom: 10px;">
        <div class="form__group">
          <div class="form__group">
            <label class="form__label">CP.:</label>
            <input
              v-model="codePostal"
              v-mask="'#####'"
              @change="getLocations"
              type="text"
              class="form__input"
              
            />
            <validation-error :validation="$v.codePostal" />
          </div>
        </div>
      </mdb-col>
    </mdb-row>

    <mdb-row>
      <mdb-col md="8" style="margin-bottom: 20px;">
        <label class="form__label">Colonia:</label>

        <select v-model="locationId" class="browser-default custom-select">
          <option
            v-for="(item, index) in listColony"
            :key="index"
            :value="item.id"
          >{{ item.colony }}</option>
        </select>
        <validation-error :validation="$v.locationId" />
      </mdb-col>
    </mdb-row>

    <mdb-row>
      <mdb-col md="4" style="margin-bottom: 10px;">
        <div class="form__group">
          <div class="form__group">
            <label class="form__label">Calle:</label>
            <input
              v-model="street"
              type="text"
              class="form__input"
              value
              style="text-transform: capitalize !important;"
            />
            <validation-error :validation="$v.street" />
          </div>
        </div>
      </mdb-col>

      <mdb-col md="2" style="margin-bottom: 10px;">
        <div class="form__group">
          <div class="form__group">
            <label class="form__label">Nº Ext.:</label>
            <input v-model="externalNumber" type="text" class="form__input" value />
            <validation-error :validation="$v.externalNumber" />
          </div>
        </div>
      </mdb-col>

      <mdb-col md="2" style="margin-bottom: 10px;">
        <div class="form__group">
          <div class="form__group">
            <label class="form__label">Nº Int.:</label>
            <input type="text" class="form__input" value v-model="interiorNumber" />
          </div>
        </div>
      </mdb-col>
    </mdb-row>

   <mdb-row class="mt-4" v-if="pdfUrl!=null">
      <mdb-col md="6">
        <div class="input-group">
          <btn :text="'¡LISTO!'" :type="'primary-admin-success'" style="float:left;"></btn>

          <img
            style="margin-top: 10px; cursor: pointer;"
            :src="'/img/icons/'+watchButton"
            @click="viewPdf(pdfUrl)"
            @mouseup="mouseUpIcon('watch')"
            @mousedown="mouseDownIcon('watch')"
            @mouseleave="mouseLeaveIcon('watch')"
          />
        </div>
      </mdb-col>
      <mdb-col md="6"></mdb-col>
    </mdb-row>

  <mdb-row class="mt-4" v-if="pdfUrl==null">
      <mdb-col md="6">
        <label for="buttonUpload" class="form__label">Sube un comprobante de domicilio:</label>
        <div v-show="pdfUrl==null" class="curp-upload">
          <label for="worker-input" class="btn-label">
            <img :src="'../../img/icons/'+uploadIcon" style="width: 20px;" />
            SUBIR COMPROBANTE
          </label>

          <input
            type="file"
            accept="application/pdf"
            name="file"
            id="worker-input"
            @change="uploadWorker"
          />
          <!--<validation-error :validation="$v.singleRe.worker"></validation-error>-->
          <validation-error :validation="$v.pdfUrl" />
        </div>
        <div v-show="pdfUrl!=null" class="input-group">
          <btn :text="'¡LISTO!'" :type="'primary-admin-success'" style="float:left;"></btn>

          <img
            style="margin-top: 10px; cursor: pointer;"
            :src="'/img/icons/'+watchButton"
            @click="viewPdf(pdfUrl)"
            @mouseup="mouseUpIcon('watch')"
            @mousedown="mouseDownIcon('watch')"
            @mouseleave="mouseLeaveIcon('watch')"
          />
        </div>
      </mdb-col>
      <mdb-col md="6"></mdb-col>
    </mdb-row>

    <Popup size="lg" ref="confirm" title="Comprobante de Domicilio">
      <div class="embed-responsive embed-responsive-16by9 z-depth-1-half" style="height: 75vh;">
        <iframe title="titulo" class="embed-responsive-item" :src="popUrl" allowfullscreen></iframe>
      </div>
      <div class="accordion__button">
        <btn
          style="float: left;"
          text="CERRAR"
          @onClick="$refs.confirm.toggleModal()"
          type="primary-block"
        />
      </div>
    </Popup>
  </div>
</template>
<script>
import Btn from "../../core/Button";
import { mdbContainer, mdbRow, mdbCol } from "mdbvue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { mask } from "vue-the-mask";
import Popup from "../../core/Popup";
import vSelect from "vue-select";
import ValidationError from "../misc/ValidationError";
import {
  required,
} from "vuelidate/lib/validators";

export default {
  name: "HomeData",
  components: {
    mdbContainer,
    mdbRow,
    vSelect,
    mdbCol,
    Btn,
    Popup,
    ValidationError,
  },
  directives: { mask },
  data() {
    return {
      infoIdIcon: "info-default.svg",
      uploadIcon: "upload-document.svg",
      watchButton: "watch-unpressed-btn.svg",
      codePostal: "",
      listColony: [],
      colony: "",
      state: "",
      city: "",
      street: "",
      externalNumber: "",
      interiorNumber: "",
      locationId: "",
      pdfUrl: null,
      filesPDF: null,
      popUrl: null,
      userAllData: "",
      personalHomeData: "",
      colonyOnData: false,
      colonyOnfirst: true,
      alreadyUpDocument: false,
      addressObject: {
        street: "",
        externalNumber: "",
        locationId: "",
        interiorNumber: "",
	  }
    };
  },
  created() {
    this.userAllData = JSON.parse(localStorage.getItem("userAllData"));

    if (this.userAllData.address != null) {
      let locID = this.userAllData.address.location.id;
      this.locationId = locID;
      this.getLocationsByID();
      this.alreadyUpDocument = true;
    }

   

    let profA = this.userAllData.documents.filter(function (item) {
       return item.documentType == "PROOF_OF_ADDRESS";
    })

    if (profA.length>0) {
       this.pdfUrl = profA[0].publicURL;
    }

    //}

    //this.personalHomeData = this.userAllData.personalMail;
  },
  validations: {
    state: {
      required,
    },
    city: {
      required,
    },
    locationId: {
      required,
    },
    codePostal: {
      required,
    },
    street: {
      required,
    },
    externalNumber: {
      required,
    },
    pdfUrl: {
      required,
    },
  },
  computed: {
    ...mapGetters({
      benefName: "getBeneficiaryName",
    }),
    beneficiaryName: {
      get() {
        return this.benefName;
      },
      set(value) {
        this.$store.commit("_setName", value);
      },
    },
  },
  methods: {
    ...mapActions(["obtainLocationsDoc", "obtainLocationByID"]),
    chooseFile() {
      document.getElementById("fileUpload").click();
    },
    chooseFileCurp() {
      document.getElementById("fileUploadCurp").click();
    },
    chooseFileColonia() {
      document.getElementById("fileUploadColonia").click();
    },
    chooseFileCartaAntec() {
      document.getElementById("fileUploadCartaAntec").click();
    },
    chooseFileIdentificacion() {
      document.getElementById("fileUploadIdentificacion").click();
    },
    mouseOverIcon() {
      let infoIdIcon = this.infoIdIcon.split("-");
      this.infoIdIcon = `${infoIdIcon[0]}-hover.svg`;
    },
    mouseLeaveIcon() {
      let infoIdIcon = this.infoIdIcon.split("-");
      this.infoIdIcon = `${infoIdIcon[0]}-default.svg`;
    },
    mouseLeaveIcon(module) {
      if (module == "upload") {
        let uploadIcon = this.uploadIcon.split("-");
        this.uploadIcon = `${uploadIcon[0]}-document.svg`;
      } else if (module == "release") {
        let releaseIcon = this.releaseIcon.split("-");
        this.releaseIcon = `${releaseIcon[0]}-default.svg`;
      } else if (module == "watch") {
        this.watchButton = "watch-unpressed-btn.svg";
      } else {
        let helpIcon = this.helpIcon.split("-");
        this.helpIcon = `${helpIcon[0]}-default.svg`;
        this.showCard = false;
      }
    },
    mouseDownIcon(module) {
      if (module == "upload") {
        let uploadIcon = this.uploadIcon.split("-");
        this.uploadIcon = `${uploadIcon[0]}-document.svg`;
      } else if (module == "watch") {
        this.watchButton = "watch-pressed-btn.svg";
      } else {
        let releaseIcon = this.releaseIcon.split("-");
        this.releaseIcon = `${releaseIcon[0]}-click.svg`;
      }
    },
    mouseUpIcon(module) {
      if (module == "upload") {
        let uploadIcon = this.uploadIcon.split("-");
        this.uploadIcon = `${uploadIcon[0]}-document.svg`;
      } else if (module == "watch") {
        this.watchButton = "watch-unpressed-btn.svg";
      } else {
        let releaseIcon = this.releaseIcon.split("-");
        this.releaseIcon = `${releaseIcon[0]}-hover.svg`;
      }
    },

    viewPdf(url) {
      this.popUrl = url;
      this.$refs.confirm.toggleModal();
    },
    uploadWorker: async function (evt) {
      this.pdfUrl = URL.createObjectURL(evt.target.files[0]);
      let aux = this;
      var rdr = new FileReader();
      rdr.onload = await function (e) {
        aux.filesPDF = e.target.result.split(",")[1];
        let proof_of_address = {
          documentType: "PROOF_OF_ADDRESS",
          value: "",
          extension:
            evt.target.files[0].type == "application/pdf" ? "pdf" : "jpeg",
          mimeType: evt.target.files[0].type,
          content: aux.filesPDF,
        };

        aux.$store.commit("setProofAddress", proof_of_address);
      };
      rdr.readAsDataURL(evt.target.files[0]);

      ////SAVE IN STORE
    },

    async getLocations() {
      //console.log("getLocations...", this.codePostal);
      if (this.codePostal.length == 5) {
        let response = await this.obtainLocationsDoc(this.codePostal);
        //console.log("response getLocations", response);
        if (response.data) {
          this.listColony = response.data.data;
          this.state = response.data.data[0].state;
          this.city = response.data.data[0].city!=''?response.data.data[0].city:response.data.data[0].municipality;
          this.locationId = response.data.data[0].id;
        }
      }
    },

    async getLocationsByID() {
      let response = await this.obtainLocationByID(this.locationId);
      //console.log("response getLocationsByID", response);
      if (response.data) {
        this.state = response.data.data.state;
        this.city = response.data.data.city;
        this.colony = response.data.data.colony;

        this.codePostal = response.data.data.zipCode;
        this.setNewColonyList();

        this.street = this.userAllData.address.street;
        this.externalNumber = this.userAllData.address.externalNumber;
        this.interiorNumber = this.userAllData.address.interiorNumber;
      }
    },

    async setNewColonyList() {
      let response = await this.obtainLocationsDoc(this.codePostal);
      if (response.data) {
        this.listColony = response.data.data;
        //console.log("listColony", this.listColony);
        this.state = response.data.data[0].state;
        this.city = response.data.data[0].city;
        this.locationId = response.data.data[0].id;
      }
    },
    getFormdata() {
      // validations
      this.$v.$touch();
      if (
        this.$v.state.required &&
        this.$v.city.required &&
        this.$v.codePostal.required &&
        this.$v.locationId.required &&
        this.$v.externalNumber.required &&
        this.$v.street.required &&
        (this.alreadyUpDocument || this.$v.pdfUrl.required )
      ) {
        
       
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
	  street(val){
		  this.addressObject.street = val
		  this.$store.commit('setAddress', this.addressObject)
	  },
	  externalNumber(val){
		  this.addressObject.externalNumber = val
		  this.$store.commit('setAddress', this.addressObject)
	  },
	  locationId(val){
		  this.addressObject.locationId = val
		  this.$store.commit('setAddress', this.addressObject)
    },
    codePostal(val){
      if(val.length == 5){
        this.getLocations()
      }
    },
	  interiorNumber(val){
		  this.addressObject.interiorNumber = val
		  this.$store.commit('setAddress', this.addressObject)
	  },

  }
};
</script>
<style>
.t1-input-colonia {
  /* max-width: 80%; */
  display: inline;
  transform: translateY(3px);
  margin-bottom: 10px !important;
}

.t1-input-curp {
  display: inline;
  max-width: 70%;
  transform: translateY(3px);
}

.t1-input-dia,
.t1-input-mes {
  text-align: center;
  display: inline;
  width: 8%;
  margin-right: 15px;
  transform: translateY(3px);
}

.t1-input-ano {
  text-align: center;
  display: inline;
  width: 12%;
  transform: translateY(3px);
}

.btn-comprobante-domicilio {
  /* margin-left: 10px; */
  display: inline;
}

.btn-acta-nacimiento {
  display: inline-block;
  margin-left: 10px;
}

.btn-upload-curp {
  display: inline;
  margin-left: 10px;
}

.info-icon {
  width: 2rem;
  height: 2rem;
  margin-left: 1rem;
  transition: transform 0.2s;
}

.info-icon:hover {
  transform: scale(1.3);
}

.radio-buttons label {
  display: block;
  color: #828282;
  font-size: 1.4rem;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  padding-left: 10px;
  padding-right: 10px;
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
  width: 15px;
  height: 15px;
  margin-right: 15px;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #f78c4f;
  background-color: #f78c4f;
}

.custom-control-label::after {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 15px;
  height: 15px;
  content: "";
  background: no-repeat 50%/50% 50%;
}

.t2-table-title-left {
  color: #3a8a65;
  font-size: 18px;
}

.t2-table-title-left img {
  width: 20px;
  height: auto;
  margin-top: -0.5rem;
  margin-right: 5px;
}

.btn-label {
  border-radius: 5px;
  background-color: #dc7134;
  padding: 10px 10px 10px 10px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
  font-weight: 600;
  font-family: Josefin Sans;
  cursor: pointer;
}

@media (max-width: 1199px) {
  .t1-input-curp {
    display: block;
    max-width: 100%;
    transform: translateY(3px);
  }

  .t1-input-dia,
  .t1-input-mes {
    width: 12%;
  }

  .t1-input-ano {
    width: 18%;
  }

  .btn-upload-curp {
    display: block;
    margin-top: 10px;
    margin-left: 0px;
  }

  .btn-acta-nacimiento {
    display: block;
    margin-left: 0px;
    margin-top: 10px;
  }
}

@media (max-width: 992px) {
  .btn-comprobante-domicilio {
    margin-left: 0px;
    display: block;
  }

  .t1-input-dia,
  .t1-input-mes {
    width: 18%;
  }

  .t1-input-ano {
    width: 28%;
  }

  .t1-input-colonia {
    max-width: 100%;
    margin-bottom: 10px;
    display: block;
  }
}

@media (max-width: 768px) {
  .t1-input-colonia {
    max-width: 100%;
  }
}

@media (max-width: 576px) {
}
</style>
